
define('ldsh!modules/accounts/companies/detail/template', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (company.isRequest) {;
__p += '\n  <div class="spinner__container">\n    <i class="ri-loader-4-fill fa-spin"></i>\n  </div>\n';
 } else { ;
__p += '\n  ';
 if (company.isError) {;
__p += '\n      <div id="activationError" class="activationContent center response">\n        <i class="naranja fa fa-exclamation-circle" style="font-size: 120px;"></i>\n        ';
 if (company.isNew()) { ;
__p += '\n          <div class="text-message">\n            <span class="i18n size20" data-i18n="[html]ACCOUNTS.COMPANIES.LBL_ERROR"></span>\n          </div>\n        ';
 } ;
__p += '\n        <div class="text-message">\n          <span class="i18n naranja size21" data-i18n="[html]ACCOUNTS.COMPANIES.LBL_ERROR_' +
__e(company.status) +
'"\n            id="errorMessage">Unknown backend error!</span>\n        </div>\n      </div>\n  ';
 } else { ;
__p += '\n    ';
 if (company.isNew()) { ;
__p += '\n      <p><strong class="i18n size20" data-i18n="ACCOUNTS.COMPANIES.LBL_NEW_COMPANY"></strong></p>\n    ';
 } else {;
__p += '\n      <p><strong class="size20">' +
__e(company.get('name') ) +
'</strong></p>\n    ';
 } ;
__p += '\n      <div id="messages-container"></div>\n      <form id="form-accounts-companys-detail" method="POST" class="bv-form" novalidate="novalidate">\n        <div id="form-company"></div>\n        <div id="accounts-service-content">\n          <h4 class="i18n" data-i18n="ACCOUNTS.COMPANIES.LBL_STATUS_SUBACCOUNT"></h4>\n          <div class="accounts-service panel panel-default" style="padding-left: 20px">\n            <div id="form-company-services"></div>\n          </div>\n        </div>\n        <div class="flex align-center justify-end gap-12 mb24">\n          <button id="cancelFormCompany" type="button" class="btn--ghost i18n"\n            data-i18n="ACCOUNTS.COMPANIES.LBL_CANCEL"></button>\n          <button id="submitButton" class="btn--primary js-save">\n            <i class="fa-li fa fa-spinner fa-spin" style="display: none;"></i>\n            <span class="i18n" data-i18n="ACCOUNTS.COMPANIES.LBL_SAVE"></span>\n          </button>\n        </div>\n      </form>\n  ';
 } ;
__p += '\n';
 } ;
__p += '\n<div id=\'renderModalServices\'></div>\n\n<hr>\n<div class="subdomain-contact i18n" data-i18n="[html]ACCOUNTS.COMPANIES.LBL_SUBDOMAIN_CONTACT"></div>\n';

}
return __p
};});

